<template>
    <div class="input-all">
      <input :type="type" :value="value" :placeholder="placeholder" @input="handleInput" />
    </div>
  </template>
  
  <script>
  export default {
    name: 'MyInput',
    data() {
      return {};
    },
    props: {
      value: [String, Number],
  
      type: {
        type: String,
        default: 'text',
      },
      placeholder: String,
    },
  
    methods: {
      handleInput(event) {
        //  'MyInput handleInput');
        this.$emit('input', event.target.value);
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .input-all {
    display: flex;
    padding-left: 27px;
    align-items: center;
  
    width: 415px;
    height: 60px;
    background: #ffffff;
    border-radius: 30px;
  
    input {
      outline: none;
      border: none;
      font-size: 18px;
      font-weight: 300;
      width: 100%;
      height: 100%;
      border-radius: 30px;
      background-color: transparent;
      &::placeholder {
        color: #999fb5;
        line-height: 25px;
      }
  
      // 解决chrome自动填充含有背景色
      &:-webkit-autofill {
        box-shadow: 0 0 0 1000px #fff inset;
      }
    }
  }
  </style>
  